import React from 'react';
import { cn } from '../../lib/utils';

function ToggleGroup({ value, onChange, children, className }) {
  return (
    <div className={cn("inline-flex rounded-md border border-white/10", className)}>
      {React.Children.map(children, child => {
        if (!React.isValidElement(child)) return child;
        const childVal = child.props.value;
        const isActive = value === childVal;
        return React.cloneElement(child, {
          _active: isActive,
          _onClick: () => onChange(childVal),
        });
      })}
    </div>
  );
}

function ToggleItem({ _active, _onClick, children, className }) {
  return (
    <button
      type="button"
      onClick={_onClick}
      className={cn(
        "px-3 py-1 text-xs font-medium transition-colors border-r border-white/10 last:border-r-0",
        _active ? "bg-cta/20 text-cta" : "text-ink-dim hover:bg-surface-2 hover:text-ink",
        className
      )}
    >
      {children}
    </button>
  );
}

export { ToggleGroup, ToggleItem };
